import React, {Fragment, useEffect, useState} from 'react';
import {Button, Modal, Form, TreeSelect, Select} from 'antd';
import {useRouteMatch} from 'react-router-dom';

export function AddSchemaRefDialog({backend, onChange}) {
    const [visible, setVisible] = useState();
    const {params} = useRouteMatch('/:env/standards/:category');
    const [form] = Form.useForm();
    const [library, setLibrary] = useState([]);
    const [availableModels, setAvailableModels] = useState([]);

    async function handleOk() {
        try {
            const values = await form.validateFields();
            setVisible(false);
            onChange(values.model);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        async function loadLibrary() {
            const data = await backend.loadLibrary();
            setLibrary(data);
        }
        loadLibrary();
    }, []);

    function handleShow() {
        form.resetFields();
        setVisible(true);
    }
    async function handleTargetSpecChange(val) {
        const [category, key] = val.split('-');

        setAvailableModels(await backend.loadModelRefs({category, key, from: params.category, env: params.env}));
    }

    async function handleModelSearch(keywords) {
        return availableModels.filter((m) => m.key.indexOf(keywords) !== -1 || m.name.indexOf(keywords) !== -1);
    }

    return (
        <Fragment>
            <Button size="small" className="addRef" onClick={handleShow}>
                add an additional schema $ref
            </Button>
            {visible && (
                <Modal
                    title="Add Schema $ref"
                    open={visible}
                    destroyOnHidden
                    okText="Add $ref"
                    footer={[
                        <Button key="cancel" className="addRef" onClick={() => setVisible(false)}>
                            Cancel
                        </Button>,
                        <Button key="submit" className="addField" type="primary" onClick={handleOk}>
                            Add $ref
                        </Button>,
                    ]}
                    onCancel={() => setVisible(false)}>
                    <Form form={form}>
                        <Form.Item name="targetSpec" label="Schema Reference" rules={[{required: true, message: 'Add Schema Reference'}]}>
                            <TreeSelect
                                showSearch
                                treeDefaultExpandAll
                                styles={{popup: {root: {maxHeight: 400, overflow: 'auto'}}}}
                                style={{width: '100%'}}
                                treeData={library}
                                onChange={handleTargetSpecChange}
                                placeholder="Please select a schema from your library"
                            />
                        </Form.Item>
                        <Form.Item name="model" label="Target Model" rules={[{required: true, message: 'Add Target Model'}]}>
                            <Select showSearch placeholder="Select a model from target specification (above)" defaultActiveFirstOption={false} onSearch={handleModelSearch} notFoundContent={null}>
                                {availableModels.map((m) => (
                                    <Select.Option key={m.link} value={m.link}>
                                        {m.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Form>
                </Modal>
            )}
        </Fragment>
    );
}
